export default __webpack_public_path__ + "static/media/promos3.1e960262.webp";